// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__24-8k","title":"FrontImage_title__1oQ2G"};